import { POOL_ABI, PharaohV2Factory } from '@trinity/pharaoh-common';
import { Contract, ZeroAddress } from 'ethers';
export class PoolService {
    constructor(runner, factoryAddress) {
        this.poolCache = new Map();
        this.runner = runner;
        this.factory = new Contract(factoryAddress, PharaohV2Factory, runner);
    }
    /**
     * Build pool key for cache
     */
    getPoolKey(tokenA, tokenB, feeTier) {
        // Sort tokens for consistent keys
        const [token0, token1] = tokenA.toLowerCase() < tokenB.toLowerCase() ? [tokenA, tokenB] : [tokenB, tokenA];
        return `${token0}:${token1}:${feeTier}`;
    }
    /**
     * Check if pool exists
     */
    async getPoolAddress(tokenA, tokenB, feeTier) {
        const key = this.getPoolKey(tokenA, tokenB, feeTier);
        // Return from cache if exists
        if (this.poolCache.has(key)) {
            return this.poolCache.get(key);
        }
        // Sort tokens (lower address first according to Uniswap V3 convention)
        const [token0, token1] = tokenA.toLowerCase() < tokenB.toLowerCase() ? [tokenA, tokenB] : [tokenB, tokenA];
        // Get pool address from factory
        const poolAddress = await this.factory.getPool(token0, token1, feeTier);
        // Cache result
        this.poolCache.set(key, poolAddress);
        return poolAddress;
    }
    /**
     * Check pool liquidity and get info
     */
    async getPoolInfo(poolAddress) {
        if (poolAddress === ZeroAddress) {
            return {
                poolAddress,
                hasLiquidity: false,
            };
        }
        try {
            const pool = new Contract(poolAddress, POOL_ABI, this.runner);
            // Get liquidity
            const liquidity = await pool.liquidity();
            const hasLiquidity = liquidity > 0n;
            // If no liquidity, return early
            if (!hasLiquidity) {
                return {
                    poolAddress,
                    hasLiquidity,
                    liquidity,
                };
            }
            // Get price data
            const slot0 = await pool.slot0();
            const sqrtPriceX96 = slot0.sqrtPriceX96;
            const tick = slot0.tick;
            // Calculate price
            const price = (Number(sqrtPriceX96) / 2 ** 96) ** 2;
            return {
                poolAddress,
                hasLiquidity,
                liquidity,
                sqrtPriceX96,
                tick,
                price,
            };
        }
        catch {
            return {
                poolAddress,
                hasLiquidity: false,
            };
        }
    }
}
